import { useState } from 'react';
import { Modal, Button, Select } from 'components/ui';

/**
 * Dialog to reject a single order item with a reason.
 * Render with a `key` of the item id so the selected reason resets per item.
 */
export function RejectOrderModal({ item, reasons, loading, onConfirm, onClose }) {
  const [reason, setReason] = useState('');

  const options = reasons.map((entry) => ({ value: entry.value, label: entry.displayValue }));

  return (
    <Modal
      isOpen={Boolean(item)}
      onClose={onClose}
      title="Reject order item"
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => onConfirm(reason)}
            isLoading={loading}
            disabled={!reason}
          >
            Reject item
          </Button>
        </>
      }
    >
      <p className="mb-3 text-sm text-slate-600">
        Rejecting <span className="font-medium text-slate-800">{item?.productName}</span>. Please
        tell us why.
      </p>
      <Select
        label="Reason"
        placeholder="Select a reason"
        options={options}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
    </Modal>
  );
}

export default RejectOrderModal;
